export enum RunGroup {
  Even = "Even",
  Odd = "Odd",
}
